import { render, staticRenderFns } from "./CurrentElectionCycleVoting.vue?vue&type=template&id=1a164a32&scoped=true&"
import script from "./CurrentElectionCycleVoting.vue?vue&type=script&lang=js&"
export * from "./CurrentElectionCycleVoting.vue?vue&type=script&lang=js&"
import style0 from "./CurrentElectionCycleVoting.vue?vue&type=style&index=0&id=1a164a32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a164a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VSkeletonLoader})
